import { useState } from "react";
import { signInWithEmailAndPassword, signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../../firebaseConfig";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const WORKFLOW_ADMIN_EMAIL = "workflow.admin@shineagri.org";

export default function WorkflowAdminLogin() {
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email.trim() || !pass)
      return toast.error("Email & Password enter karo");
    try {
      setLoading(true);
      const { user } = await signInWithEmailAndPassword(
        auth,
        email.trim().toLowerCase(),
        pass,
      );
      const [token, profileSnap] = await Promise.all([
        user.getIdTokenResult(true),
        getDoc(doc(db, "nafed_users", user.uid)),
      ]);
      const profile = profileSnap.exists() ? profileSnap.data() : {};
      const allowed =
        user.email?.toLowerCase() === WORKFLOW_ADMIN_EMAIL.toLowerCase() ||
        token.claims.workflowAdmin === true ||
        (profile.role === "SHINE_AGRI_ADMIN" &&
          profile.status === "APPROVED" &&
          profile.isActive === true);
      if (!allowed) {
        await signOut(auth);
        return toast.error(
          "Only authorised Shine Agri Workflow Admin can access this portal",
        );
      }
      sessionStorage.setItem("workflowAdminVerified", "true");
      toast.success("Shine Agri NAFED Workflow login successful");
      navigate("/workflow/admin", { replace: true });
    } catch (error) {
      console.error(error);
      toast.error(
        error?.code === "auth/invalid-credential"
          ? "Invalid email or password"
          : error.message,
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="wal">
      <style>{CSS}</style>
      <Toaster position="top-center" />
      <section>
        <div className="brand">
          <img src="/images/nafed-logo.png" alt="NAFED" />
          <div>
            <small>SHINE AGRI CONTROLLED WORKFLOW</small>
            <h1>NAFED Technical Workflow</h1>
            <p>Survey · Soil Test · Design · Estimate · DPR</p>
          </div>
        </div>
        <div className="form">
          <span>AUTHORISED ADMIN ACCESS</span>
          <h2>Workflow Administrator Login</h2>
          <p>Only NAFED-connected projects and allocated PMCs are processed.</p>
          <form onSubmit={handleLogin}>
            <label>Email Address</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={WORKFLOW_ADMIN_EMAIL}
              autoComplete="username"
            />
            <label>Password</label>
            <input
              type="password"
              value={pass}
              onChange={(e) => setPass(e.target.value)}
              placeholder="Enter secure password"
              autoComplete="current-password"
            />
            <button disabled={loading}>
              {loading ? "Verifying..." : "Secure Login"}
            </button>
          </form>
        </div>
      </section>
    </main>
  );
}

const CSS = `.wal{min-height:100vh;display:grid;place-items:center;padding:24px;background:radial-gradient(circle at 15% 15%,#1d754755,transparent 30%),linear-gradient(135deg,#07172f,#123b62 55%,#115137);font-family:Inter,"Segoe UI",Arial;color:#10233e}.wal>section{width:min(980px,100%);display:grid;grid-template-columns:1.05fr .95fr;overflow:hidden;border:1px solid #ffffff44;border-radius:24px;background:#fff;box-shadow:0 35px 90px #0007}.brand{padding:50px 38px;display:flex;align-items:center;gap:22px;background:linear-gradient(145deg,#102e59,#17613f);color:#fff}.brand img{width:150px;height:125px;object-fit:contain;background:#fff;border-radius:18px;padding:12px}.brand small,.form>span{font-size:11px;font-weight:900;letter-spacing:.12em;color:#bce7c8}.brand h1{margin:7px 0;font-size:31px}.brand p{margin:0;color:#dcece3}.form{padding:42px}.form>span{color:#19713f}.form h2{margin:7px 0}.form>p{margin:0 0 25px;color:#64748b}.form form{display:grid;gap:8px}.form label{margin-top:8px;font-weight:800}.form input{padding:13px;border:1px solid #9eabbc;border-radius:8px}.form button{margin-top:14px;border:0;border-radius:8px;padding:13px;background:#163d73;color:#fff;font-weight:900}@media(max-width:760px){.wal>section{grid-template-columns:1fr}.brand{padding:25px}.brand img{width:100px;height:85px}.form{padding:28px}}`;
